import { alpha, Backdrop, Typography } from '@mui/material';
import { ComponentProps, ElementType } from 'react';

import { PRIMITIVES } from '@/styles/tokens/colors';
import { zIndexes } from '@/styles/zIndexes';

import { Loader } from '../Loader/Loader';

interface LoadingOverlayProps extends ComponentProps<typeof Backdrop> {
  updatingText?: string;
  /**
   * Optional wrapper component that the spinner and updatingText render inside of.
   * Receives children (the spinner + text) as its only prop.
   */
  Wrapper?: ElementType;
}

export function LoadingOverlay({
  updatingText,
  Wrapper,
  ...backdropProps
}: LoadingOverlayProps) {
  const content = (
    <>
      <Loader circularProgressProps={{ size: 40 }} />
      {updatingText && (
        <Typography variant="title-s">{updatingText}</Typography>
      )}
    </>
  );

  return (
    <Backdrop
      sx={{
        zIndex: zIndexes.HIGHLIGHT,
        position: 'absolute',
        backgroundColor: alpha(PRIMITIVES.WHITE, 0.88),
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
      {...backdropProps}
    >
      {Wrapper ? <Wrapper>{content}</Wrapper> : content}
    </Backdrop>
  );
}
